export default __webpack_public_path__ + "assets/images/73eb4448765d2a80eeec2c11cd5811ae.svg";